import React from "react";
import Card from "@mui/material/Card";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Typography from "@mui/material/Typography";
import { useTranslate } from "react-admin";
// import groupBy from "lodash/groupBy";

import CardIcon from "./CardIcon";
import { styled } from "@mui/material/styles";

const MainWrapper = styled("div")(({ theme }) => ({
  flex: "1",
  marginLeft: "1em",
  marginTop: 20,
}));

const StyledCard = styled(Card)(({ theme }) => ({
  overflow: "inherit",
  textAlign: "right",
  padding: 16,
  minHeight: 52,
}));

const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

const NbNewOrders = ({ value, orders = [] }) => {
  const translate = useTranslate();
  // const ordersByStatus = groupBy(orders, (o) => o.status);

  return (
    <MainWrapper>
      <CardIcon Icon={ShoppingCartIcon} bgColor="#ff9800" />
      <StyledCard>
        {orders.map((k) => (
          <span key={k.status}>
            <Title variant="body2">{k.status}</Title>
            <Typography variant="h5" component="h2">
              {k.orderCount}
            </Typography>
          </span>
        ))}
      </StyledCard>
    </MainWrapper>
  );
};

export default NbNewOrders;
